export const ORIGINS = {
  DIGITAL_INVOICE: "8000",
  ENROLLMENT_EMAIL: "2001",
  PAPERLESS_ENROLLMENT_EMAIL: "2002",
  POLICY_RENEWAL: "2003",
  POLICY_ENDORSEMENT: "2004",
};
